import { Reducer } from 'redux';
import { IReduxAction } from 'app/types/actions';
import { LoadingActionTypes as types, ILoadingState } from './types';

const initialState = {
  isLoading: false,
  actionConfirmedText: null,
};

const reducer: Reducer<ILoadingState> = (
  state = initialState,
  action: IReduxAction,
) => {
  switch (action.type) {
    case types.LOADING_START:
      return {
        ...state,
        isLoading: true,
      };
    case types.LOADING_FINISH:
      return {
        ...state,
        isLoading: false,
      };
    case types.ACTION_CONFIRMED:
      return {
        ...state,
        actionConfirmedText: action.payload,
      };

    default:
      return state;
  }
};

export default reducer;
